export const GUEST = 'guest';
export const BASIC = 'basic';
export const SILVER = 'silver';
export const GOLD = 'gold';
export const PLATINUM = 'platinum';
export const RBI = 'rbi';
export const TWEETS = 'tweets';
